import type { RouteObject } from 'react-router'

import { lazyRoute } from '@web/app/routes/lazy-route'
import { DeviceRoute } from '@web/entities/device'

const deviceGroupAddRoute = lazyRoute(
  () => import('@web/widgets/device-group-configurator/ui/device-group-add'),
  ({ DeviceGroupAdd }) => DeviceGroupAdd
)

const deviceGroupEditRoute = lazyRoute(
  () => import('@web/widgets/device-group-configurator/ui/device-group-edit'),
  ({ DeviceGroupEdit }) => DeviceGroupEdit
)

export const DeviceRouter: RouteObject[] = [
  {
    path: DeviceRoute.GeneratorGroupAdd,
    lazy: deviceGroupAddRoute
  },
  {
    path: DeviceRoute.GeneratorGroupId,
    lazy: deviceGroupEditRoute
  },
  {
    path: DeviceRoute.GeneratorId,
    lazy: lazyRoute(
      () =>
        import(
          '@web/widgets/generator-configurator/ui/generator-configurator-edit'
        ),
      ({ GeneratorConfiguratorEdit }) => GeneratorConfiguratorEdit
    )
  },
  {
    path: DeviceRoute.GeneratorAdd,
    lazy: lazyRoute(
      () =>
        import(
          '@web/widgets/generator-configurator/ui/generator-configurator-add'
        ),
      ({ GeneratorConfiguratorAdd }) => GeneratorConfiguratorAdd
    )
  },
  {
    path: DeviceRoute.Vp3701GroupAdd,
    lazy: deviceGroupAddRoute
  },
  {
    path: DeviceRoute.Vp3701GroupId,
    lazy: deviceGroupEditRoute
  },
  {
    path: DeviceRoute.Vp3701DeviceId,
    lazy: lazyRoute(
      () => import('@web/pages/device-vp-3701/ui/vp-3701-page'),
      ({ Vp3701Page }) => Vp3701Page
    ),
    children: [
      {
        index: true,
        lazy: lazyRoute(
          () =>
            import('@web/widgets/vp-3701-configurator/ui/vp3701-configurator'),
          ({ Vp3701Configurator }) => Vp3701Configurator
        )
      },
      {
        path: DeviceRoute.Vp3701BatteryMonitoring,
        lazy: lazyRoute(
          () =>
            import(
              '@web/widgets/vp-3701-battery-monitoring/ui/vp3701-battery-monitoring'
            ),
          ({ Vp3701BatteryMonitoring }) => Vp3701BatteryMonitoring
        )
      }
    ]
  },
  {
    path: DeviceRoute.Vp3701ModuleId,
    element: null
  },
  {
    path: DeviceRoute.Vp3701ChannelId,
    element: null
  },
  {
    path: DeviceRoute.Vp3711GroupAdd,
    lazy: deviceGroupAddRoute
  },
  {
    path: DeviceRoute.Vp3711GroupId,
    lazy: deviceGroupEditRoute
  },
  {
    path: DeviceRoute.Vp3711MeasurementPostId,
    lazy: lazyRoute(
      () =>
        import(
          '@web/widgets/vp-3711-measurement-post-configurator/ui/vp-3711-measurement-post-configurator'
        ),
      ({ Vp3711MeasurementPostConfigurator }) =>
        Vp3711MeasurementPostConfigurator
    )
  },
  {
    path: DeviceRoute.Vp3711ModuleId,
    lazy: lazyRoute(
      () =>
        import(
          '@web/widgets/vp-3711-module-configurator/ui/vp3711-module-configurator'
        ),
      ({ Vp3711ModuleConfigurator }) => Vp3711ModuleConfigurator
    )
  },
  {
    path: DeviceRoute.Vp3711ChannelId,
    lazy: lazyRoute(
      () =>
        import(
          '@web/widgets/vp-3711-channel-configurator/ui/vp-3711-channel-configurator'
        ),
      ({ Vp3711ChannelConfigurator }) => Vp3711ChannelConfigurator
    )
  },
  {
    path: DeviceRoute.ControllerGroupAdd,
    lazy: deviceGroupAddRoute
  },
  {
    path: DeviceRoute.ControllerGroupId,
    lazy: deviceGroupEditRoute
  },
  {
    path: DeviceRoute.ControllerId,
    lazy: lazyRoute(
      () => import('@web/pages/device-controller/ui/controller-page'),
      ({ ControllerPage }) => ControllerPage
    )
  },
  {
    path: DeviceRoute.ControllerChannelId,
    lazy: lazyRoute(
      () =>
        import('@web/pages/device-controller-channel/ui/controller-channel'),
      ({ ControllerChannel }) => ControllerChannel
    )
  }
]
